"use strict";
const ColorScale = require("./ColorScale");
module.exports = ColorScale;
